import type { TranslatorService } from "@app/services/translator";

export const AwardName = {
  BEST_CANADIANA_BUS_COMPANY: "best_canadian_bus_company",
  MOST_POPULAR_AMONG_TRAVELLERS: "most_popular_among_travellers",
  BEST_WIFI_CONNECTION: "best_wi-fi_connection",
  BEST_SHUTTLE_SERVICE: "best_shuttle_service",
  MOST_ON_TIME_SERVICE: "most_on-time_service",
  BEST_CUSTOMER_SERVICE: "best_customer_service",
  BEST_FOR_CROSS_BORDER_TRIPS: "best_for_cross-border_trips",
  TOP_RATED_INTERNATIONAL_TRAVELLERS: "top_rated_by_international_travellers"
} as const;
export type AwardName = (typeof AwardName)[keyof typeof AwardName];

const OPERATOR_AWARD_ID_REGEXES = [
  /(\d{4})_(best_canadian_bus_company)/,
  /(\d{4})_(most_popular_among_travellers)/,
  /(\d{4})_(best_wi-fi_connection)/,
  /(\d{4})_(best_shuttle_service)/,
  /(\d{4})_(most_on-time_service)/,
  /(\d{4})_(best_customer_service)/,
  /(\d{4})_(best_for_cross-border_trips)/,
  /(\d{4})_(top_rated_by_international_travellers)/
];

export function isAnOperatorAwardAnnotationId(id?: string): boolean {
  return !!id && OPERATOR_AWARD_ID_REGEXES.some(regex => regex.test(id));
}

export function getOperatorAwardLabel(
  name: AwardName,
  translator: TranslatorService
): string {
  switch (name) {
    case AwardName.BEST_CANADIANA_BUS_COMPANY:
      return translator.t("!operator.awards.best_canadian_bus_company");
    case AwardName.MOST_POPULAR_AMONG_TRAVELLERS:
      return translator.t("!operator.awards.most_popular_among_travellers");
    case AwardName.BEST_WIFI_CONNECTION:
      return translator.t("!operator.awards.best_wi-fi_connection");
    case AwardName.BEST_SHUTTLE_SERVICE:
      return translator.t("!operator.awards.best_shuttle_service");
    case AwardName.MOST_ON_TIME_SERVICE:
      return translator.t("!operator.awards.most_on-time_service");
    case AwardName.BEST_CUSTOMER_SERVICE:
      return translator.t("!operator.awards.best_customer_service");
    case AwardName.BEST_FOR_CROSS_BORDER_TRIPS:
      return translator.t("!operator.awards.best_for_cross-border_trips");
    case AwardName.TOP_RATED_INTERNATIONAL_TRAVELLERS:
      return translator.t(
        "!operator.awards.top_rated_by_international_travellers"
      );
    default:
      return "";
  }
}

export function extractOperatorAwardData(id: string): {
  name: AwardName;
  year: number;
} {
  const regex = OPERATOR_AWARD_ID_REGEXES.find(regex => regex.test(id));
  const data = regex?.exec(id);
  const year = parseInt(data?.[1] || "0", 10);
  const name = (data?.[2] || "") as AwardName;
  return { name, year };
}

export function getOperatorAwardCategory(
  name: AwardName,
  translator: TranslatorService
): string {
  switch (name) {
    case AwardName.BEST_CANADIANA_BUS_COMPANY:
      return translator.t(
        "!operator.awards.category.best_canadian_bus_company"
      );
    case AwardName.MOST_POPULAR_AMONG_TRAVELLERS:
      return translator.t(
        "!operator.awards.category.most_popular_among_travellers"
      );
    case AwardName.BEST_WIFI_CONNECTION:
      return translator.t("!operator.awards.category.best_wi-fi_connection");
    case AwardName.BEST_SHUTTLE_SERVICE:
      return translator.t("!operator.awards.category.best_shuttle_service");
    case AwardName.MOST_ON_TIME_SERVICE:
      return translator.t("!operator.awards.category.most_on-time_service");
    case AwardName.BEST_CUSTOMER_SERVICE:
      return translator.t("!operator.awards.category.best_customer_service");
    case AwardName.BEST_FOR_CROSS_BORDER_TRIPS:
      return translator.t(
        "!operator.awards.category.best_for_cross-border_trips"
      );
    case AwardName.TOP_RATED_INTERNATIONAL_TRAVELLERS:
      return translator.t(
        "!operator.awards.category.top_rated_by_international_travellers"
      );
    default:
      return "";
  }
}
